import SpmConstants from 'sg-spm-constants';
import CommonAdobeAnalyticsUtil from '../Common/CommonAdobeAnalyticsUtil';
import { SG_AA_COVER_LEVELS, SG_AA_COVER_TYPE_PRODUCT, SG_AA_FIELDS_ADDONS } from '../AdobeAnalyticsConstants';

export default class SpmAdobeAnalyticsUtil {
    static buildProductName(coverType) {
        let productName = `${SG_AA_COVER_TYPE_PRODUCT.PERSONAL_AUTO.toLowerCase()} - `;
        switch (coverType) {
            case SpmConstants.COVER_LEVEL_CODES.SAGA_SELECT:
            case SG_AA_COVER_LEVELS.SELECT:
                productName += SG_AA_COVER_LEVELS.SELECT.toLowerCase();
                break;
            case SpmConstants.COVER_LEVEL_CODES.SAGA_PLUS:
            case SG_AA_COVER_LEVELS.PLUS:
                productName += SG_AA_COVER_LEVELS.PLUS.toLowerCase();
                break;
            case SpmConstants.COVER_LEVEL_CODES.SAGA_STANDARD:
            case SG_AA_COVER_LEVELS.STANDARD:
                productName += SG_AA_COVER_LEVELS.STANDARD.toLowerCase();
                break;
            default:
                productName += SG_AA_COVER_LEVELS.UNKNOWN.toLowerCase();
        }
        return productName;
    }

    static buildBreakdownCoverName(termCode) {
        return `${SG_AA_FIELDS_ADDONS.hasBreakdownCover.id} ${CommonAdobeAnalyticsUtil.getTypelistValue('SPMSBACoverOptions_Ext', termCode)}`;
    }

    static buildModificationObject(modification) {
        const taggingModification = {};

        taggingModification.modificationCategory = CommonAdobeAnalyticsUtil.getTypelistValue(
            'VehicleModCategory_Ext', modification.modificationCategory
        );
        if (modification.modificationCategory !== SpmConstants.PORTAL_MOTORHOME) {
            taggingModification.modificationType = CommonAdobeAnalyticsUtil.getTypelistValue(
                'VehicleModification_Ext', modification.modificationType
            );
        }
        if (modification.modificationCost.amount !== undefined) {
            taggingModification.modificationCost = modification.modificationCost.amount;
        }
        if (modification.hasNormalFootControl !== undefined) {
            taggingModification.hasNormalFootControl = modification.hasNormalFootControl;
        }
        if (modification.disabledDriver !== undefined) {
            taggingModification.disabledDriver = CommonAdobeAnalyticsUtil.getTypelistValue('DisabledDriver_Ext', modification.disabledDriver);
        }
        if (modification.hasSleepingCookingFacilities !== undefined) {
            taggingModification.hasSleepingCookingFacilities = modification.hasSleepingCookingFacilities;
        }
        if (modification.isLowPerfIncrease !== undefined) {
            taggingModification.isLowPerfIncrease = modification.isLowPerfIncrease;
        }
        if (modification.isTowingPerformance !== undefined) {
            taggingModification.isTowingPerformance = modification.isTowingPerformance;
        }
        if (modification.hasBodyKit !== undefined) {
            taggingModification.hasBodyKit = modification.hasBodyKit;
        }
        return taggingModification;
    }

    static buildClaimsObject(claim) {
        const taggingClaim = {};
        if (claim.type !== undefined) {
            taggingClaim.claimType = CommonAdobeAnalyticsUtil.getTypelistValue(
                'MotorClaimType_Ext', claim.type
            );
        }
        if (claim.whoWasAtFault !== undefined) {
            taggingClaim.faultStatus = CommonAdobeAnalyticsUtil.getTypelistValue(
                'ClaimFaultRating_Ext', claim.whoWasAtFault
            );
        }
        return taggingClaim;
    }
}
